import React from 'react';
import { Routes as Switch, Route } from 'react-router-dom';
import { useSelector } from 'react-redux';

import MyRoute from './MyRoute';
import Login from '../pages/Login';
import Page404 from '../pages/Page404';
import Dashboard from '../pages/Dashboard';
import DashEstrategico from '../pages/DashEstrategico';
import DashDre from '../pages/DashDre';
import DashMapaProducao from '../pages/DashMapaProducao';
import Empresas from '../pages/Empresas';
import Empresa from '../pages/Empresa';
import Register from '../pages/Register';
import Motoristas from '../pages/Motoristas';
import Motorista from '../pages/Motorista';
import Clientes from '../pages/Clientes';
import Cliente from '../pages/Cliente';
import Locais from '../pages/Locais';
import Local from '../pages/Local';
import Veiculos from '../pages/Veiculos';
import Veiculo from '../pages/Veiculo';
import Carretas from '../pages/Carretas';
import Carreta from '../pages/Carreta';
import Favorecidos from '../pages/Favorecidos';
import Favorecido from '../pages/Favorecido';
import Funcionario from '../pages/Funcionario';
import Funcionarios from '../pages/Funcionarios';
import User from '../pages/User';
import Users from '../pages/Users';
import Detalhes from '../pages/Detalhes';
import Detalhe from '../pages/Detalhe';
import TipoDespesas from '../pages/TipoDespesas';
import TipoDespesa from '../pages/TipoDespesa';
import ControleDespesas from '../pages/ControleDespesas';
import ControleDespesa from '../pages/ControleDespesa';
import ControleViagens from '../pages/ControleViagens';
import RelatorioViagens from '../pages/RelatorioViagens';
import Viagens from '../pages/Viagens';
import Viagem from '../pages/Viagem';
import ControleViagensMotorista from '../pages/ControleViagensMotorista';
import Despesa from '../pages/Despesa';
import Receita from '../pages/Receita';
import Adiantamento from '../pages/Adiantamento';
import Home from '../pages/Home';
import Posto from '../pages/Posto';
import Postos from '../pages/Postos';
import ViagemMotorista from '../pages/ViagemMotorista';
import TipoDespesasDetalhes from '../pages/TipoDespesasDetalhes';
import TipoDespesasDetalhe from '../pages/TipoDespesasDetalhe';
import Integration from '../pages/Integration';
import Ranking from '../pages/DashPostosRanking';

export default function Routes() {
  const isLoggedIn = useSelector((state) => state.auth.isLoggedIn);
  const isAdmin = useSelector((state) => state.auth.user.flag_admin);

  return (
    <Switch>
      <Route
        exact
        path="/"
        element={
          // eslint-disable-next-line no-nested-ternary
          isLoggedIn ? (
            isAdmin === 3 ? (
              <ViagemMotorista />
            ) : (
              <Home />
            )
          ) : (
            <Login />
          )
        }
      />
      <Route
        exact
        path="/home/"
        element={
          <MyRoute isClosed>
            {isAdmin === 3 ? <ViagemMotorista /> : <Home />}
          </MyRoute>
        }
      />
      <Route
        exact
        path="/viagemmotorista/"
        element={
          <MyRoute isClosed>
            <ViagemMotorista />
          </MyRoute>
        }
      />
      <Route
        exact
        path="/tipodespesadetalhe/:id1/edit/:id2"
        element={
          <MyRoute isClosed>
            <TipoDespesasDetalhe />
          </MyRoute>
        }
      />
      <Route
        exact
        path="/tipodespesadetalhe/:id1"
        element={
          <MyRoute isClosed>
            <TipoDespesasDetalhe />
          </MyRoute>
        }
      />
      <Route
        exact
        path="/tipodespesadetalhes/:id"
        element={
          <MyRoute isClosed>
            <TipoDespesasDetalhes />
          </MyRoute>
        }
      />
      <Route
        exact
        path="/dashboard/"
        element={
          <MyRoute isClosed>
            <Dashboard />
          </MyRoute>
        }
      />
      <Route
        exact
        path="/dashestrategico/"
        element={
          <MyRoute isClosed>
            <DashEstrategico />
          </MyRoute>
        }
      />
      <Route
        exact
        path="/dashdre/"
        element={
          <MyRoute isClosed>
            <DashDre />
          </MyRoute>
        }
      />
      <Route
        exact
        path="/ranking/"
        element={
          <MyRoute isClosed>
            <Ranking />
          </MyRoute>
        }
      />
      <Route
        exact
        path="/dashmapaproducao/"
        element={
          <MyRoute isClosed>
            <DashMapaProducao />
          </MyRoute>
        }
      />
      <Route
        exact
        path="/controledespesas/"
        element={
          <MyRoute isClosed>
            <ControleDespesas />
          </MyRoute>
        }
      />
      <Route
        exact
        path="/controledespesa/:id/edit"
        element={
          <MyRoute isClosed>
            <ControleDespesa />
          </MyRoute>
        }
      />
      <Route
        exact
        path="/controledespesa/"
        element={
          <MyRoute isClosed>
            <ControleDespesa />
          </MyRoute>
        }
      />
      <Route
        exact
        path="/tipodespesas/"
        element={
          <MyRoute isClosed>
            <TipoDespesas />
          </MyRoute>
        }
      />
      <Route
        exact
        path="/tipodespesa/:id/edit"
        element={
          <MyRoute isClosed>
            <TipoDespesa />
          </MyRoute>
        }
      />
      <Route
        exact
        path="/tipodespesa/:id/detalhes"
        element={
          <MyRoute isClosed>
            <TipoDespesa />
          </MyRoute>
        }
      />
      <Route
        exact
        path="/tipodespesa/"
        element={
          <MyRoute isClosed>
            <TipoDespesa />
          </MyRoute>
        }
      />
      <Route
        exact
        path="/controleviagens/:id/lancamento"
        element={
          <MyRoute isClosed>
            <ControleViagens />
          </MyRoute>
        }
      />
      <Route
        exact
        path="/controleviagens/:id/motorista"
        element={
          <MyRoute isClosed>
            <ControleViagensMotorista />
          </MyRoute>
        }
      />
      <Route
        exact
        path="/relatorioviagens/:id"
        element={
          <MyRoute isClosed>
            <RelatorioViagens />
          </MyRoute>
        }
      />
      <Route
        exact
        path="/despesa/:id1"
        element={
          <MyRoute isClosed>
            <Despesa />
          </MyRoute>
        }
      />
      <Route
        exact
        path="/despesa/:id1/:id2/edit"
        element={
          <MyRoute isClosed>
            <Despesa />
          </MyRoute>
        }
      />
      <Route
        exact
        path="/despesa/"
        element={
          <MyRoute isClosed>
            <Despesa />
          </MyRoute>
        }
      />
      <Route
        exact
        path="/receita/:id1"
        element={
          <MyRoute isClosed>
            <Receita />
          </MyRoute>
        }
      />
      <Route
        exact
        path="/receita/:id1/:id2/edit"
        element={
          <MyRoute isClosed>
            <Receita />
          </MyRoute>
        }
      />
      <Route
        exact
        path="/receita/"
        element={
          <MyRoute isClosed>
            <Receita />
          </MyRoute>
        }
      />
      <Route
        exact
        path="/viagens/"
        element={
          <MyRoute isClosed>
            <Viagens />
          </MyRoute>
        }
      />
      <Route
        exact
        path="/viagem/:id/edit"
        element={
          <MyRoute isClosed>
            <Viagem />
          </MyRoute>
        }
      />
      <Route
        exact
        path="/viagem/"
        element={
          <MyRoute isClosed>
            <Viagem />
          </MyRoute>
        }
      />
      <Route
        exact
        path="/empresas/"
        element={
          <MyRoute isClosed>
            <Empresas />
          </MyRoute>
        }
      />
      <Route
        exact
        path="/empresa/"
        element={
          <MyRoute isClosed>
            <Empresa />
          </MyRoute>
        }
      />
      <Route
        exact
        path="/empresa/:id/edit"
        element={
          <MyRoute isClosed>
            <Empresa />
          </MyRoute>
        }
      />
      <Route
        exact
        path="/funcionarios/"
        element={
          <MyRoute isClosed>
            <Funcionarios />
          </MyRoute>
        }
      />
      <Route
        exact
        path="/funcionario/"
        element={
          <MyRoute isClosed>
            <Funcionario />
          </MyRoute>
        }
      />
      <Route
        exact
        path="/funcionario/:id/edit"
        element={
          <MyRoute isClosed>
            <Funcionario />
          </MyRoute>
        }
      />
      <Route
        exact
        path="/motoristas/"
        element={
          <MyRoute isClosed>
            <Motoristas />
          </MyRoute>
        }
      />
      <Route
        exact
        path="/motorista/"
        element={
          <MyRoute isClosed>
            <Motorista />
          </MyRoute>
        }
      />
      <Route
        exact
        path="/motorista/:id/edit"
        element={
          <MyRoute isClosed>
            <Motorista />
          </MyRoute>
        }
      />
      <Route
        exact
        path="/clientes/"
        element={
          <MyRoute isClosed>
            <Clientes />
          </MyRoute>
        }
      />
      <Route
        exact
        path="/cliente/"
        element={
          <MyRoute isClosed>
            <Cliente />
          </MyRoute>
        }
      />
      <Route
        exact
        path="/cliente/:id/edit"
        element={
          <MyRoute isClosed>
            <Cliente />
          </MyRoute>
        }
      />
      <Route
        exact
        path="/locais/"
        element={
          <MyRoute isClosed>
            <Locais />
          </MyRoute>
        }
      />
      <Route
        exact
        path="/local/"
        element={
          <MyRoute isClosed>
            <Local />
          </MyRoute>
        }
      />
      <Route
        exact
        path="/local/:id/edit"
        element={
          <MyRoute isClosed>
            <Local />
          </MyRoute>
        }
      />
      <Route
        exact
        path="/favorecidos/"
        element={
          <MyRoute isClosed>
            <Favorecidos />
          </MyRoute>
        }
      />
      <Route
        exact
        path="/favorecido/:id/edit"
        element={
          <MyRoute isClosed>
            <Favorecido />
          </MyRoute>
        }
      />
      <Route
        exact
        path="/favorecido/"
        element={
          <MyRoute isClosed>
            <Favorecido />
          </MyRoute>
        }
      />
      <Route
        exact
        path="/veiculos/"
        element={
          <MyRoute isClosed>
            <Veiculos />
          </MyRoute>
        }
      />
      <Route
        exact
        path="/veiculo/:id/edit"
        element={
          <MyRoute isClosed>
            <Veiculo />
          </MyRoute>
        }
      />
      <Route
        exact
        path="/veiculo/"
        element={
          <MyRoute isClosed>
            <Veiculo />
          </MyRoute>
        }
      />
      <Route
        exact
        path="/carretas/"
        element={
          <MyRoute isClosed>
            <Carretas />
          </MyRoute>
        }
      />
      <Route
        exact
        path="/carreta/:id/edit"
        element={
          <MyRoute isClosed>
            <Carreta />
          </MyRoute>
        }
      />
      <Route
        exact
        path="/carreta/"
        element={
          <MyRoute isClosed>
            <Carreta />
          </MyRoute>
        }
      />
      <Route
        exact
        path="/detalhes/"
        element={
          <MyRoute isClosed>
            <Detalhes />
          </MyRoute>
        }
      />
      <Route
        exact
        path="/detalhe/:id/edit"
        element={
          <MyRoute isClosed>
            <Detalhe />
          </MyRoute>
        }
      />
      <Route
        exact
        path="/detalhe/"
        element={
          <MyRoute isClosed>
            <Detalhe />
          </MyRoute>
        }
      />
      <Route
        exact
        path="/adiantamento/:id1"
        element={
          <MyRoute isClosed>
            <Adiantamento />
          </MyRoute>
        }
      />
      <Route
        exact
        path="/adiantamento/:id1/:id2/edit"
        element={
          <MyRoute isClosed>
            <Adiantamento />
          </MyRoute>
        }
      />
      <Route
        exact
        path="/adiantamento/"
        element={
          <MyRoute isClosed>
            <Adiantamento />
          </MyRoute>
        }
      />
      <Route
        exact
        path="/postos/"
        element={
          <MyRoute isClosed>
            <Postos />
          </MyRoute>
        }
      />
      <Route
        exact
        path="/posto/"
        element={
          <MyRoute isClosed>
            <Posto />
          </MyRoute>
        }
      />
      <Route
        exact
        path="/posto/:id/edit"
        element={
          <MyRoute isClosed>
            <Posto />
          </MyRoute>
        }
      />
      <Route
        exact
        path="/integration/"
        element={
          <MyRoute isClosed>
            <Integration />
          </MyRoute>
        }
      />
      <Route
        exact
        path="/users/"
        element={
          <MyRoute isClosed>
            <Users />
          </MyRoute>
        }
      />
      <Route
        exact
        path="/user/"
        element={
          <MyRoute isClosed>
            <User />
          </MyRoute>
        }
      />
      <Route
        exact
        path="/user/:id/edit"
        element={
          <MyRoute isClosed>
            <User />
          </MyRoute>
        }
      />
      <Route
        exact
        path="/login/"
        element={
          <MyRoute isClosed={false}>
            <Login />
          </MyRoute>
        }
      />
      <Route
        exact
        path="/register/"
        element={
          <MyRoute isClosed>
            <Register />
          </MyRoute>
        }
      />
      <Route
        exact
        path="*"
        element={
          <MyRoute isClosed>
            <Page404 />
          </MyRoute>
        }
      />
    </Switch>
  );
}
